import amplitude from 'amplitude-js';

const isProd = process.env.REACT_APP_API_URL?.includes('prodback.anetaed.org');

export const initAmplitude = (): void => {
  if (isProd) {
    amplitude.getInstance().init('69ae4a60daa489275f4417917705f2f7');
  }
};

export const setAmplitudeUserDevice = (installationToken: string): void => {
  return amplitude.getInstance().setDeviceId(installationToken);
};

export const logEvent = (eventName: string): void => {
  if (isProd) {
    amplitude.getInstance().logEvent(eventName);
  }
};

// export const setAmplitudeUserProperties = (properties) => {
//   amplitude.getInstance().setUserProperties(properties);
// };

// export const sendAmplitudeData = (eventType, eventProperties) => {
//   amplitude.getInstance().logEvent(eventType, eventProperties);
// };
